import moment from "moment";

/**
 * Return a string representing only the date.
 * @param {Date} date A JavaScript Date object
 */
function formatDate(date) {
  return moment(date).format("MM/DD/YYYY");
}

/**
 * Return a string representing the date and time.
 * @param {Date} date A JavaScript Date object
 */
function formatDatetime(date) {
  return moment(date).format("MM/DD/YYYY hh:mm A");
}

/**
 * Return a string representing the formatted phone number if it's 10-digits
 * long. Otherwise, return the original provided number.
 * @param {String|Number} phoneNumber The phone number to format
 */
function formatPhone(phoneNumber) {
  if (phoneNumber && String(phoneNumber).length === 10) {
    const string = String(phoneNumber).trim();
    return `(${string.substr(0, 3)}) ${string.substr(3, 3)}-${string.substr(
      6
    )}`;
  }
  return phoneNumber;
}

function formatPayload(payload) {
  if (payload.email) return { ...payload, email: payload.email.toLowerCase() };
  return { ...payload };
}

export { formatDate, formatDatetime, formatPhone, formatPayload };



// WEBPACK FOOTER //
// ./src/utilities/format.js